<script lang="ts">
  export let title: string;
  export let iconName: string = "";
</script>

<div class="aside-block">
  <div class="aside-block-title">
    <div class="left-column">
      <div class="title">{title}</div>
      {#if $$slots.subtitle}
        <div class="desc"><slot name="subtitle" /></div>
      {/if}
    </div>

    {#if iconName}
      <div class="right-column">
        <svg class="icon" width="42" height="42" aria-label={title}>
          <use xlink:href="#{iconName}" />
        </svg>
      </div>
    {/if}
  </div>

  <slot />
</div>

<style lang="scss">
  .aside-block {
    padding: 30px 30px 40px;
    background: $text-reverse-color;
    box-shadow: 2px 2px 3px 0 rgba(0, 0, 0, 0.11);
    margin-bottom: 40px;
  }

  .aside-block-title {
    display: flex;
    justify-content: space-between;
    margin-bottom: 25px;
  }
  .right-column {
    margin-left: 10px;
  }
  .title {
    @include h2;
    margin-bottom: 4px;
  }
  .icon {
    fill: $key-color;
  }
</style>
